import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-eventbrite',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Eventbrite icon</title><path d="M10.542 5.81c2.653-.6 5.3.487 6.775 2.54L5.591 11c.405-2.479 2.298-4.591 4.951-5.19zm6.84 9.746a6.47 6.47 0 0 1-3.919 2.634c-2.67.604-5.335-.501-6.804-2.582l11.763-2.657 1.915-.433L24 11.691a11.57 11.57 0 0 0-.305-2.333C22.205 3.04 15.76-.9 9.303.558 2.846 2.017-1.18 8.322.31 14.642c1.491 6.319 7.935 10.259 14.392 8.8 3.805-.86 6.765-3.402 8.25-6.638z"/></svg>`,
    styles: []
})
export class SimpleIconsEventbriteComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#F05537';
    @Input() className: string = 'simple-icons-eventbrite'
    constructor() {}
    ngOnInit(): void {}
}
